import { useState, useMemo } from 'react';

const useStepsController = (stepsQty: number | undefined) => {
  const [currentStepId, setCurrentStepId] = useState<number>(0);

  const isLastStep = useMemo(
    () => (stepsQty ? currentStepId === stepsQty - 1 : false),
    [currentStepId, stepsQty]
  );

  const isFirstStep = currentStepId === 0;

  const goForward = () => {
    if (stepsQty && currentStepId === stepsQty - 1) {
      return;
    }
    setCurrentStepId(prevState => prevState + 1);
  };

  const goBack = () => {
    if (currentStepId === 0) {
      return;
    }
    setCurrentStepId(prevState => prevState - 1);
  };

  return {
    currentStepId,
    setCurrentStepId,
    goForward,
    goBack,
    isLastStep,
    isFirstStep,
  };
};

export { useStepsController };
